import React, { useState } from "react";
import { IconDisclosure, Dropdown, SearchInput } from "@toddle-edu/ds-web";
import { useTranslation } from "react-i18next";
import classes from "./StandardsDataGridHeader.scss";
import { useFilters } from "../../../../providers/FilterProvider";
import { FILTER_TYPES } from "PlannerElementDataSet/modules/PlannerElementDataSetConstants";
import FiltersOverlay from "UIComponents/FiltersOverlay";
import {
  getFilterOverlayOptions,
  getAllFiltersCount,
  getAppliedFiltersCountForFilter,
} from "../../../../modules/utils";
import { FilterOutlined } from "@toddle-edu/ds-icons";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import ConfigureColumnsWrapper from "./components/ConfigureColumnsWrapper";

const TEST_ID_PREFIX = "planning-standardsDataGridHeader";

const { SEARCH } = FILTER_TYPES;

const StandardsDataGridHeader = props => {
  const {
    grades = [],
    subjects = [],
    tags = [],
    showLoaderOverHeader,
    defaultColumns,
    currentColumns,
    updateColumns,
    columnIdsForConfigureModal,
    properties,
  } = props;
  const { t } = useTranslation(["common"]);
  const {
    state,
    handleFilterUpdate,
    handleApplyFilters,
    defaultFilters,
  } = useFilters();
  const [isOpen, setIsOpen] = useState(false);

  const filterOverlayOptions = getFilterOverlayOptions({
    grades,
    subjects,
    tags,
    defaultColumns,
  });

  const getAllFiltersCountFn = ({ currentFilters }) => {
    return getAllFiltersCount({ currentFilters });
  };

  const getAppliedFiltersCountForFilterFn = ({ filterKey, filterValue }) => {
    return getAppliedFiltersCountForFilter({ filterKey, filterValue });
  };

  const onApply = ({ filters }) => handleApplyFilters(filters);

  const handleClose = () => setIsOpen(false);

  const appliedFiltersCount = getAllFiltersCount({ currentFilters: state });

  const handleSearchChange = val => handleFilterUpdate(SEARCH, val);

  if (showLoaderOverHeader) {
    return (
      <>
        <div className={classes.searchContainer}>
          <SkeletonLoader height="36px" width="100%" />
        </div>

        <div className={classes.filterSkeleton}>
          <SkeletonLoader height="36px" width="60px" />
        </div>
      </>
    );
  }

  return (
    <>
      <div className={classes.searchContainer}>
        <SearchInput
          value={state[SEARCH]}
          onChange={handleSearchChange}
          focusSearchBySlash
          placeholder={t("common:search_for_a_with_label", {
            label: t("common:standard"),
          })}
          testId={TEST_ID_PREFIX}
        />
      </div>
      <div className={classes.rightHeader}>
        <ConfigureColumnsWrapper
          currentColumns={currentColumns}
          updateColumns={updateColumns}
          columnIdsForConfigureModal={columnIdsForConfigureModal}
          properties={properties}
        />
        <Dropdown
          overlay={
            <FiltersOverlay
              options={filterOverlayOptions}
              currentFilters={state}
              getAllFiltersCount={getAllFiltersCountFn}
              getAppliedFiltersCountForFilter={
                getAppliedFiltersCountForFilterFn
              }
              onApply={onApply}
              handleClose={handleClose}
              defaultFilters={defaultFilters}
              testId={TEST_ID_PREFIX}
            />
          }
          visible={isOpen}
          onVisibleChange={setIsOpen}
        >
          <IconDisclosure
            icon={<FilterOutlined />}
            type="outlined"
            variant="neutral"
            badgeProps={{
              value: appliedFiltersCount,
              variant: "dark",
              shape: "circle",
            }}
            testId={`${TEST_ID_PREFIX}-filtersTrigger`}
          />
        </Dropdown>
      </div>
    </>
  );
};

export default StandardsDataGridHeader;
